import { IKeywordEntityEvents } from '@core/interfaces/entity.interface';


// ENUMS #############################################################
// API enums *********************************************************
// UI enums *********************************************************


// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************


// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class ArchivingKeywordTMO {
	public color?: string = undefined;

	public created?: Date = undefined;

	public createdBy?: string = undefined;

	public id?: string = undefined;

	public lastModified?: Date = undefined;

	public lastModifiedBy?: string = undefined;

	public name?: string = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class ArchivingKeyword extends ArchivingKeywordTMO {
	public ui?: IKeywordEntityEvents = {};
	public etag?: string = undefined;
	public isSelected?: boolean = undefined;
}
